import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {}

  first_checkbox_selected() {}

  second_checkbox_selected() {
    const second_checkbox = document.getElementById(
      "task_closure_data_defects_and_outstanding_work_acceptance",
    )
    this.selectedCheckbox(second_checkbox)
  }

  third_checkbox_selected() {
    const third_checkbox = document.getElementById(
      "task_closure_data_refused_acceptance_condition_determination",
    )
    const note = document.getElementById("task_closure_data_note")
    this.selectedCheckbox(third_checkbox)
    if (third_checkbox.checked) {
      note.classList.remove("hidden")
    } else {
      note.classList.add("hidden")
    }
  }

  isChecked(targetCheckbox, targetField) {
    if (targetCheckbox.checked) {
      if (targetField.classList.contains("hidden")) {
        targetField.classList.remove("hidden")
      }
    }
  }

  selectedCheckbox(checkboxName) {
    const elements = document.getElementsByClassName(`hideable`)
    const mangelContent = document.getElementById("mangel-parent-div")
    const mangelCheckbox = document.getElementById("mangelCheckbox")
    const furtherReservationCheckbox = document.getElementById("further-reservation-checkbox")
    const furtherReservationInputField = document.getElementById("further-reservation-input-field")

    if (checkboxName.checked) {
      this.isChecked(mangelCheckbox, mangelContent)
      this.isChecked(furtherReservationCheckbox, furtherReservationInputField)
      Array.from(elements).forEach((ele) => {
        if (
          ele.classList.contains("hidden") &&
          ele !== mangelContent &&
          ele !== furtherReservationInputField
        ) {
          ele.classList.remove("hidden")
        }
      })
    } else {
      Array.from(elements).forEach((ele) => {
        if (!ele.classList.contains("hidden")) {
          ele.classList.add("hidden")
        }
      })
    }
  }

  handleMangelChange(event) {
    const mangelContent = document.getElementById("mangel-parent-div")
    if (event.target.checked) {
      mangelContent.classList.remove("hidden")
    } else {
      mangelContent.classList.add("hidden")
    }
  }

  handleFurtherReservationChange(event) {
    const inputField = document.getElementById("further-reservation-input-field")
    if (event.target.checked) {
      inputField.classList.remove("hidden")
    } else {
      inputField.classList.add("hidden")
    }
  }
}
